<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 text-center">
        
          © {{year}} NABH. All Rights Reserved. 
      </div>
      <!-- <div class="col-sm-6">
        <div class="text-sm-right d-none d-sm-block">
          Design & Develop by QCI
        </div>
      </div> -->
    </div>
  </div>
</footer>
